<script lang="ts">
	import Icon from '../atoms/Icon.svelte'
	import iconCheck from '@/icons/icon_checkmark_circled.svg'
	import iconError from '@/icons/icon_error_circled.svg'
	import Tooltip from '../atoms/Tooltip.svelte'
	import { TooltipPlacements } from '../types/enums'
	import { t } from '../../i18n/i18n'
	import { formatBytes } from '../utils/utils'

	const MAXIMUM_FILE_SIZE_BYTES: number = 12000000 // 12 MB

	export let filename: string
	export let date: string
	// In bytes
	export let size: number

	let attachmentCanBeSent: boolean = false
	let formattedSize: string = ''

	// TODO svelte v5 use $derived
	$: attachmentCanBeSent = size <= MAXIMUM_FILE_SIZE_BYTES
	$: formattedSize = formatBytes(size)
</script>

<div class="attachment-info" class:attachment-error={!attachmentCanBeSent}>
	<div>
		<h3 title={filename}>{filename}</h3>
		{#if attachmentCanBeSent}
			<Tooltip
				msg={$t('UI.AttachmentInfo.tooltip.success')}
				placementTtip={TooltipPlacements.TOP}
				zIndex={1000003}
			>
				<Icon src={iconCheck} size={24} />
			</Tooltip>
		{:else}
			<Tooltip
				msg={$t('UI.AttachmentInfo.tooltip.failed.tooBig')}
				placementTtip={TooltipPlacements.TOP}
				zIndex={1000003}
				maxWidthTtip={250}
			>
				<Icon src={iconError} size={24} />
			</Tooltip>
		{/if}
	</div>
	<div>
		<p>{date}</p>
		<p class="attachment-info__filesize">{formattedSize}</p>
	</div>
</div>

<style lang="scss">
	@use '$styles/global';

	.attachment-info {
		@include global.flex-col(0.625rem);

		padding: 0.5rem 0.875rem;
		border-radius: 0.25rem;
		border: 1px solid black;
		background-color: white;

		/* Flex behavior: at least 170px, may grow, but cap at 300px */
		flex: 1 1 170px; /* grow and shrink, base size 170px */
		max-width: 300px; /* hard cap */
		width: 100%;

		& > div {
			@include global.flex-row(0.625rem, $justify: space-between);

			width: 100%;
		}

		&.attachment-error {
			border: 1px solid var(--color-gray-400);

			& * {
				color: var(--color-gray-400);
			}
		}
	}

	p,
	h3 {
		/* TODO If the the grid does not take over 'restricting' the max space for the component and it overflows,
    /  for the ellipsis to work correctly, we need to specify a max-width here. Potentially including breakpoints for mobile etc. */
		margin: 0;
		word-break: break-word;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	p.attachment-info__filesize {
		color: var(--color-gray-400);
		white-space: nowrap;
	}
</style>
